import { PaymentTerm } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum AdtPaymentTermActionTypes {
    FETCH_JOBSITE_PAYMENT_TERM_DETAILS = '[ADT Pay met Terms] Fetch Payment Terms Detail Of Jobsite',
    LOAD_JOBSITE_PAYMENT_TERM = '[ADT Paymet Terms] Load Jobsite Payment Term Details',
    LOAD_PAYMENT_TERM_SELECTED = '[ADT Paymet Terms] Select Payment Term',
    RESET_PAYMENT_TERM = '[ADT Paymet Terms] Reset',
}

export class FetchAdtJobsitePaymentTermsDetailsAction implements Action {
    readonly type = AdtPaymentTermActionTypes.FETCH_JOBSITE_PAYMENT_TERM_DETAILS;

    constructor(public payload: number) { }
}

/**
 * Load payment terms
 */
export class LoadAdtJobsitePaymentTermDetailAction implements Action {
    readonly type = AdtPaymentTermActionTypes.LOAD_JOBSITE_PAYMENT_TERM;

    constructor(public payload: PaymentTerm) { }
}

/**
 * Payment term selected
 */
export class LoadPaymentTermSelectedAction implements Action {
    readonly type = AdtPaymentTermActionTypes.LOAD_PAYMENT_TERM_SELECTED;

    constructor(public payload: PaymentTerm) { }
}

/**
 * Reset payment terms
 */
export class AdtResetPaymentTermsAction implements Action {
    readonly type = AdtPaymentTermActionTypes.RESET_PAYMENT_TERM;

    constructor() { }
}

export type AdtPaymentTermActions =
    | FetchAdtJobsitePaymentTermsDetailsAction
    | LoadAdtJobsitePaymentTermDetailAction
    | LoadPaymentTermSelectedAction
    | AdtResetPaymentTermsAction;
